import { useCallback, useEffect, useState } from 'react';
import {
  Edit,
  SelectableAccordion,
  Spinner,
  Typography,
} from '@lamimed/pantheon';
import Image from 'next/legacy/image';

import { Activity } from 'models/Activity';

import { off, on } from 'utils/events';

import { useProduct } from 'templates/Product/useProduct';

import { useSubproduct } from './useSubproduct';

import * as S from './styles';

export const Subproduct: React.FC = () => {
  const [open, setOpen] = useState(false);
  const openAccordion = useCallback(() => setOpen(true), []);

  const { data } = useSubproduct();

  const {
    selectedSubproduct,
    setSelectedSubproduct,
    scrollToSubproductAccordion,
  } = useProduct();

  const handleSelect = (item: Activity) => {
    setSelectedSubproduct(item);

    scrollToSubproductAccordion();

    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((current) => !current);
  };

  useEffect(() => {
    on('subproductAccordion:open', openAccordion);

    return () => {
      off('subproductAccordion:open', openAccordion);
    };
  }, [openAccordion]);

  return (
    <S.Wrapper id="accordion-subproduct">
      <SelectableAccordion
        open={open}
        variant={selectedSubproduct ? 'primary' : 'neutral_light'}
      >
        <SelectableAccordion.Header
          open={open}
          showControls={!selectedSubproduct}
          onToggle={handleToggle}
        >
          {!selectedSubproduct && (
            <S.HeaderContent>
              <Typography variant="heading_4" marginBottom="small">
                Scegli il tuo servizio
              </Typography>

              <Typography>Seleziona</Typography>
            </S.HeaderContent>
          )}

          {!!selectedSubproduct && (
            <S.ListItem
              key={selectedSubproduct.activityId}
              onClick={() => setSelectedSubproduct(null)}
              selected
            >
              <S.ListItemIcon>
                <div>
                  <Image
                    width={32}
                    height={32}
                    src={`/images/typology/${selectedSubproduct?.activityId}.svg`}
                  />
                </div>
              </S.ListItemIcon>

              <Typography variant="heading_4" color="text__light">
                <strong>{selectedSubproduct.activityTitle}</strong>
              </Typography>

              <S.ListItemEdit>
                <Edit color="secondary" width={32} height={32} />
              </S.ListItemEdit>
            </S.ListItem>
          )}
        </SelectableAccordion.Header>

        <SelectableAccordion.Body open={open}>
          {data && (
            <ul>
              {data.map((item) => (
                <S.ListItem
                  key={item.activityId}
                  onClick={() => handleSelect(item)}
                >
                  <S.ListItemIcon>
                    <div>
                      <Image
                        width={32}
                        height={32}
                        src={`/images/typology/${item.activityId}.svg`}
                      />
                    </div>
                  </S.ListItemIcon>

                  <Typography>{item.activityTitle}</Typography>

                  <S.ListItemDivider />

                  <Typography textAlign="right">{item.price}</Typography>
                </S.ListItem>
              ))}
            </ul>
          )}

          {!data && <Spinner size="medium" />}
        </SelectableAccordion.Body>
      </SelectableAccordion>
    </S.Wrapper>
  );
};
